module.exports.pick = (obj, ...attr) => {
  return attr.reduce((acc, k) => {
    if (obj.hasOwnProperty(k)) {
      acc[k] = obj[k];
    }
    return acc;
  }, {});
};



//////////////////
// WEBPACK FOOTER
// /home/kryd0s/tmp/widgetbot/node_modules/engine.io-client/lib/util.js
// module id = 98
// module chunks = 0